<template>

    <label :for="inputId" class="form-label">{{labelText}}</label>

    <select v-if="optionList" type="select" class="form-select-bs" :id="inputId" v-model="myModel" @change="update" @blur="this.$emit('blur')" :disabled="disabled == 1" >
        <option value="-1">Select an Item</option>
        <option v-for="optionItem in optionList" :key="optionItem.key" :value="optionItem.key">{{optionItem.value}}</option>
    </select>

    <div class="errorMessageForm" v-for="error of myErrors" :key="error.$uid">
        {{error.$message}}
    </div>

</template>
  
<script>
export default {
    name: "DropdownInput",
    props: {
        inputId:String,
        labelText:String,
        inputVModel: Object,
        optionList:Array,
        objectKey:String,
        myErrors:Array,
        disabled:Number,
    },
    data() {
        return {
            myModel:''
        };
    },
    mounted(){
        // console.log("mount dropdown");
       this.myModel = this.inputVModel; 
       if(this.myModel == "" || this.myModel == 0){
        this.myModel = "-1"; 
       }
    },
    methods:{
        update(){
            this.$emit("UpdateForm", this.objectKey, this.myModel);
        }
    },
    watch:{
        inputVModel(newVal,oldVal){
            //console.log("old value: ", oldVal, "new value: ", newVal);
            oldVal;
            if(newVal == 0 || newVal == "")
                newVal = -1; 

            this.myModel = newVal;
        }
    },
};
</script>
  <style>
.form-select-bs{
    width:100%;
    height:38px;
    border-color:lightgrey;
    border-radius:3px;
    font-size:16px;
}
.form-select-bs option{
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-white-space:pre-wrap;
    -moz-white-space:pre-wrap;
}
      .errorMessageForm {
          color: #DC143C;
      }
select:disabled{
    color:#495057;
    background-color: #e9ecef;
}
</style>